module.exports = __webpack_public_path__ + "static/media/externalTest.fbe00164.svg";